import { useState } from "react";
import { Star } from "lucide-react";
import { useTranslation } from "react-i18next";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/_atoms/dropdown-menu";
import { MenuDotsButton } from "@/components/_molecules/menu-dots-button";
import { SidebarNavElement } from "@/components/_templates/sidebar/sidebar-nav-element";
import { SidebarSectionToggle } from "@/components/_templates/sidebar/sidebar-section-toggle";
import { useCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";
import { makeWorkspaceUrl } from "@/domain/workspace/lib/make-workspace-url";

import { useDeleteUserFavorite } from "../hooks/api/use-delete-user-favorite";
import { useGetUserFavoriteList } from "../hooks/api/use-get-user-favorite";

export const SidebarAppFavorites = () => {
  const { t } = useTranslation("user");
  const { t: tCommon } = useTranslation("common");
  const [expanded, setExpanded] = useState(true);

  const { currentWorkspace } = useCurrentWorkspaceContext();
  const { favoriteList } = useGetUserFavoriteList({
    workspaceId: currentWorkspace?.id,
  });
  const { deleteFavorite } = useDeleteUserFavorite();

  if (favoriteList.length === 0) {
    return null;
  }

  return (
    <>
      <SidebarSectionToggle
        label={t("favorites.title")}
        expanded={expanded}
        onToggle={() => {
          setExpanded(!expanded);
        }}
      />
      {expanded && favoriteList.length > 0 && (
        <>
          {favoriteList.map((favorite) => (
            <div key={favorite.id} className="group relative flex h-8 w-full">
              <SidebarNavElement
                to={makeWorkspaceUrl({ workspace: currentWorkspace, path: favorite.pageUrl })}
                className="h-8 w-full "
              >
                <Star className="mr-2 h-3 w-3 fill-current text-yellow-500" />

                <div className="flex min-w-0 max-w-[80%]">
                  <div className="pointer-events-none truncate pb-0 pl-1.5 pr-0.5 pt-0 text-sm leading-8">
                    {favorite.pageName}
                  </div>
                </div>
              </SidebarNavElement>
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <MenuDotsButton
                    className="absolute right-1 top-1/2 h-6 w-6 -translate-y-1/2"
                    aria-label={t("favorites.options")}
                  />
                </DropdownMenuTrigger>
                <DropdownMenuContent>
                  <DropdownMenuItem
                    onClick={() => {
                      void deleteFavorite({
                        id: favorite.id,
                      });
                    }}
                  >
                    {tCommon("actions.remove")}
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          ))}
        </>
      )}
    </>
  );
};
